"use strict";

import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import BaseControl from "D5Utils/form_fields/BaseControl";
import { getDatePlaceholder } from "D5Utils/functions";

var DateControl =
/*#__PURE__*/
function (_BaseControl) {
  _inherits(DateControl, _BaseControl);

  function DateControl() {
    _classCallCheck(this, DateControl);

    return _possibleConstructorReturn(this, _getPrototypeOf(DateControl).apply(this, arguments));
  }

  _createClass(DateControl, [{
    key: "dispose",
    value: function dispose() {
      this.$_element.dxDateBox('dispose');
      this.$_element.remove();
    }
  }, {
    key: "instance",
    value: function instance() {
      try {
        return this.$_element.dxDateBox('instance');
      } catch (e) {
        console.error(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      this.$_element = this.$_element.dxDateBox(_objectSpread({
        type: this.props.dType,
        placeholder: getDatePlaceholder(this.props.dType),
        showClearButton: true,
        useMaskBehavior: true
      }, this._buildControlProps()));
    }
  }]);

  return DateControl;
}(BaseControl);

export { DateControl as default };